module.exports = __webpack_public_path__ + "static/img/study_report.03fda345.png";